// Single source of truth for the app version.
// Bump this whenever the site is published to production so the admin panel
// makes it obvious which build is live.
//
// SemVer:  MAJOR . MINOR . PATCH
//   MAJOR  → breaking changes or a full redesign
//   MINOR  → new features (CMS, comments, auth, etc.)
//   PATCH  → bug fixes and small tweaks
//
// Update PUBLISHED_ON to the date you hit Deploy.
export const APP_VERSION = "1.17.2";
export const PUBLISHED_ON = "2026-09-06";
